module.exports = __webpack_public_path__ + "img/wa05.a700772a.jpg";